// extracted by mini-css-extract-plugin
module.exports = {"container":"ibm-logout__container--3k-qQ","llama_icon":"ibm-logout__llama_icon--r_mXG","message":"ibm-logout__message--5ReUc"};